import { addLabelArray } from "helpers/addLabelArray";
import {loginTypes } from "./loginTypes"

const {
  SET_INFO_LOGIN,
  CLOSE_SESSION_LOGIN,
  // NEW_PRINTER,
  // EDIT_PRINTER,
  // DELETE_PRINTER,
  SET_INACTIVE_SESSION,
  SET_MS_URL,
  UPDATE_LOGIN_INFO
  // SEND_MS_DATA
} = loginTypes;

const INITIAL_STATE = {
  username: "",
  password: "",
  token: null,
  user: null,
  inactive: false,
  id: "",
  urlMS: "",
  rules: [],
  config: {
    printer: []
  },
};

export const loginReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_INFO_LOGIN:
      return {
        ...state,
        token: payload.token,
        user: payload.name,
        rules: payload.rules,
        username: payload.username,
        id: payload.id,
        config: {
          printer: payload.config.printer,
        },
        id: payload.id,
      };

    case UPDATE_LOGIN_INFO:
      // debugger
      return {
        ...state,
        config: payload,
      };
    case CLOSE_SESSION_LOGIN:
      return {
        ...INITIAL_STATE,
      };

    // case NEW_PRINTER:
    //   return {
    //     ...state,
    //     config: {
    //       ...state.config,
    //       printers: [payload, ...state.config.printers] ,
    //     },
    //   }
    // case EDIT_PRINTER:
    //   return {
    //     ...state,
    //     config: {
    //       ...state.config,
    //       printers: state.config.printers.map(printer => printer.id === payload.id ? {...printer,  ...payload} : printer)
    //     }
    //   }
    // case DELETE_PRINTER:
    //   return {
    //     ...state,
    //     config: {
    //       ...state.config,
    //       printers: state.config.printers.filter(printer => printer.id !== payload),
    //     }
    //   }
    
    case SET_INACTIVE_SESSION: 
    return {
      ...state,
      inactive: payload
    }

      
      case SET_MS_URL:
        return {
          ...state,
          urlMS: payload
        }
    
    default:
      return state;
  }
};